export const TabMap = ['home', 'facts', 'compare', 'learn', 'decide', 'summary']

export const GetTopicNavigationInfoById = (navigationInfo, id) => {
  if (navigationInfoIsValid(navigationInfo)) {
    for (const topic of navigationInfo) {
      if (topic && topic.id === id) {
        return topic
      }
    }
  }
  return {id: null, tab: null, title: null, visited: false}
}

export const GetTopicNavigationInfoByPathName = (navigationInfo, pathName) => {
  let id = pathName
  if (typeof pathName === 'string' && pathName.indexOf('/') !== -1) {
    let pathParts = pathName.split('/')
    while (pathParts.length > 0) {
      const part = pathParts.pop()
      if (part !== '') {
        id = part
        break
      }
    }
  }
  return GetTopicNavigationInfoById(navigationInfo, id)
}

const navigationInfoIsValid = (navigationInfo) => {
  return navigationInfo && Array.isArray(navigationInfo) && navigationInfo.length !== 0
}



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/common/TabNavigation/index.js